import * as yup from 'yup'
import moment from 'moment'
import { isAfterMinDate } from 'presentation/utils/validators/is-after-min-date'
import { isValidDate } from 'presentation/utils/validators/is-valid-data'

const PRIVATE_HEALTH_INSURANCE_CODE = 304

const validationSchema = yup.object().shape({
  notify: yup.object().shape({
    doctor: yup.object().shape({
      byEmail: yup.boolean().nullable(),
      bySms: yup.boolean().optional()
    }),
    secretary: yup.object().shape({
      byEmail: yup.boolean().optional(),
      bySms: yup.boolean().optional()
    })
  }),
  email: yup.object().shape({
    patient: yup.string().email().optional(),
    doctor: yup.string().email().optional(),
    secretary: yup.string().email().optional()
  }),
  phone: yup.object().shape({
    patient: yup.string().optional(),
    doctor: yup.string().optional(),
    secretary: yup.string().optional()
  }),
  passwordValidUntil: yup.object().shape(
    {
      date: yup
        .string()
        .nullable()
        .when('text', {
          is: (val: any) => Boolean(val),
          then: yup.string().nullable().notRequired(),
          otherwise: yup
            .string()
            .nullable()
            .required('Ao menos um campo de validade da senha é obrigatório')
            .test('date-validation', 'Digite uma data válida', isValidDate)
            .test(
              'min-date',
              'A data de validade não pode ser menor que a data atual',
              isAfterMinDate(moment().subtract(1, 'days').toDate())
            )
        }),
      text: yup
        .string()
        .nullable()
        .when('date', {
          is: (val: any) => Boolean(val),
          then: yup.string().nullable().notRequired(),
          otherwise: yup
            .string()
            .required('Ao menos um campo de validade da senha é obrigatório')
        })
    },
    [['text', 'date']]
  ),
  password: yup.string().required('Campo obrigatório'),
  procedures: yup.array().required(),
  proceduresObservation: yup.string().max(2000, 'Máximo 2000 caracteres'),
  opmeVerification: yup.string().required('Selecione uma opção'),
  opmeObservation: yup.string().when('opmeVerification', {
    is: (val: string) =>
      val === 'OPME negado' || val === 'OPME autorizado com divergencia',
    then: yup.string().max(2000, 'Máximo 2000 caracteres'),
    otherwise: yup.string().nullable()
  }),
  generalObservations: yup.string().max(2000, 'Máximo 2000 caracteres'),
  documents_attached: yup.array().when('health_insurance_code', {
    is: PRIVATE_HEALTH_INSURANCE_CODE,
    then: yup.array().nullable().notRequired(),
    otherwise: yup.array().min(1, 'Upload de guia autorizada é obrigatório')
  }),
  active_status: yup.string().required('Selecione uma opção')
})

export default validationSchema
